<template>
  <div class="m-icon" :class="[hoverable ? 'hoverable': '', active ? 'active' : '',]"
    ref="mainIcon" :width="width" :height="height" @click="$emit('click')">
    <svg :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" class="icon">
      <image :xlink:href="`/static/icons/${name}.svg`" :width="width" :height="height"
        :stroke="color" />
    </svg>
  </div>
</template>
<script>
export default {
  name: 'mIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    folder: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: '#D6A046',
    },
    hoverable: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/variables.scss";
.m-icon{
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  &.active{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    width: 60px;
    background: transparent;
    border-radius: 50%;
    /* .icon{
      filter: invert(100%) brightness(500%) contrast(150%);
    } */
  }
}
</style>



// WEBPACK FOOTER //
// src/components/materialIcon.vue